import AxiosService from "plugins/TS-lib-utils-public/services/AxiosService";

class AuthPatientsService extends AxiosService {
  constructor() {
    super("auth");
  }
  sendHelp = async (email, type = "patient") => {
    return await this.post(
      `/patients/help`,
      email
    );
  };

  changeEmail = async (email, password, { cancelToken = null } = {}) => {
    const response = await this.post(`/patients/change-email`, 
      {
        email: email,
        password: password
      },
      {
        headers: {
            Authorization: `Bearer ${this.getToken()}`,
        },
        cancelToken: cancelToken
    });
    return response;
  };

  verifyHash = async (auth_user_id, hash, fieldName) => {
    try {
      const response = await this.get(`/patients/check-request-hash/${hash}`,
        {
          headers: {
              auth_user_id: auth_user_id,
              field_name: fieldName,
              Authorization: `Bearer ${this.getToken()}`,
          },
      });
      return response;
    } catch (e) {
      return null;
    }
  };

  confirmHashRequest = async (password, auth_user_id, hash, fieldName) => {
    try {
      const response = await this.post(`/patients/confirm-request-hash/${hash}`,
        {
          password: password
        },
        {
          headers: {
              auth_user_id: auth_user_id,
              field_name: fieldName,
              Authorization: `Bearer ${this.getToken()}`,
          },
      });
      return response;
    } catch (e) {
      return null;
    }
  };

  cancelHashRequest = async (auth_user_id, hash, fieldName) => {
    try {
      const response = await this.get(`/patients/cancel-request-hash/${hash}`,
        {
          headers: {
              auth_user_id: auth_user_id,
              field_name: fieldName,
              Authorization: `Bearer ${this.getToken()}`,
          },
      });
      return response;
    } catch (e) {
      return null;
    }
  };

  getActiveRequests = async ({ cancelToken = null } = {}) => {
    try {
      const response = await this.get(`/patients/get-pending-requests`,
        {
          headers: {
              Authorization: `Bearer ${this.getToken()}`,
          },
          cancelToken: cancelToken
      });
      return response;
    } catch (e) {
      return null;
    }
  };
}

export default new AuthPatientsService();
